export default __webpack_public_path__ + "b277c810866c6e2e1fd00d75234ddf43.png";